/**
 * In-house icon set. WinDocs ships no icon library, so new glyphs are added
 * here as 24x24 stroked paths.
 *
 * House rules: 24x24 viewBox, stroke only (never fill), 1.5 stroke width,
 * round caps and joins. That keeps every glyph optically consistent and lets
 * the icon inherit colour from its parent via `currentColor`.
 */
export const PATHS = {
  home: 'M3 10.6 12 3.4l9 7.2M5.5 9.3V20a.8.8 0 0 0 .8.8h11.4a.8.8 0 0 0 .8-.8V9.3',
  document:
    'M13.8 3.2H6.9a1.7 1.7 0 0 0-1.7 1.7v14.2a1.7 1.7 0 0 0 1.7 1.7h10.2a1.7 1.7 0 0 0 1.7-1.7V8.4zM13.8 3.2v5.2h5',
  documents:
    'M8.5 7.2V5a1.7 1.7 0 0 1 1.7-1.7h5.6L19.8 7v9.1a1.7 1.7 0 0 1-1.7 1.7h-1.6M15.2 3.3v4h4M4.2 10.9a1.7 1.7 0 0 1 1.7-1.7h5.6l3.4 3.4v7.4a1.7 1.7 0 0 1-1.7 1.7H5.9a1.7 1.7 0 0 1-1.7-1.7z',
  folder:
    'M3.4 6.9a1.8 1.8 0 0 1 1.8-1.8h3.6l2 2h7.8a1.8 1.8 0 0 1 1.8 1.8v8.4a1.8 1.8 0 0 1-1.8 1.8H5.2a1.8 1.8 0 0 1-1.8-1.8z',
  search: 'M18.5 18.5 15 15M16.6 10.8a5.8 5.8 0 1 1-11.6 0 5.8 5.8 0 0 1 11.6 0',
  plus: 'M12 5.2v13.6M5.2 12h13.6',
  minus: 'M5.2 12h13.6',
  check: 'M4.8 12.4 9.5 17 19.2 7',
  close: 'M6.2 6.2 17.8 17.8M17.8 6.2 6.2 17.8',
  'chevron-down': 'M6.5 9.3 12 14.7l5.5-5.4',
  'chevron-up': 'M6.5 14.7 12 9.3l5.5 5.4',
  'chevron-right': 'M9.3 6.5 14.7 12l-5.4 5.5',
  'chevron-left': 'M14.7 6.5 9.3 12l5.4 5.5',
  menu: 'M4 6.5h16M4 12h16M4 17.5h16',
  settings:
    'M4 7.5h8M16.5 7.5H20M4 16.5h4M12.5 16.5H20M14.2 7.5a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0M10.7 16.5a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0',
  users:
    'M15.8 20v-1.7a3.4 3.4 0 0 0-3.4-3.4H6.6a3.4 3.4 0 0 0-3.4 3.4V20M12.9 7.7a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.8 0M20.8 20v-1.7a3.4 3.4 0 0 0-2.6-3.3M15.6 4.5a3.4 3.4 0 0 1 0 6.5',
  user: 'M19 20.2v-1.9a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v1.9M16 7.6a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  building:
    'M4.5 20.5h15M6.2 20.5V4.8a1 1 0 0 1 1-1h9.6a1 1 0 0 1 1 1v15.7M9.3 7.7h1.9M12.8 7.7h1.9M9.3 11.3h1.9M12.8 11.3h1.9M10.6 20.5v-4.3h2.8v4.3',
  upload: 'M12 16.2V4.4M7.6 8.8 12 4.4l4.4 4.4M4.2 15.9v3.5a1 1 0 0 0 1 1h13.6a1 1 0 0 0 1-1v-3.5',
  download:
    'M12 4.4v11.8M7.6 11.8 12 16.2l4.4-4.4M4.2 15.9v3.5a1 1 0 0 0 1 1h13.6a1 1 0 0 0 1-1v-3.5',
  trash:
    'M4.2 6.9h15.6M9.4 6.9V4.8a1 1 0 0 1 1-1h3.2a1 1 0 0 1 1 1v2.1M6.4 6.9l.9 13a1 1 0 0 0 1 .9h7.4a1 1 0 0 0 1-.9l.9-13',
  edit: 'M4.2 19.8h3.6L19.3 8.3a1.7 1.7 0 0 0 0-2.5l-1.1-1.1a1.7 1.7 0 0 0-2.5 0L4.2 16.2zM14.8 6.2l3 3',
  filter: 'M3.6 5.3h16.8l-6.5 7.7v5.9l-3.8 1.8V13z',
  'more-horizontal':
    'M12.9 12a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M19.4 12a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M6.4 12a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0',
  sun: 'M15.7 12a3.7 3.7 0 1 1-7.4 0 3.7 3.7 0 0 1 7.4 0M12 2.8v2M12 19.2v2M5.5 5.5l1.4 1.4M17.1 17.1l1.4 1.4M2.8 12h2M19.2 12h2M5.5 18.5l1.4-1.4M17.1 6.9l1.4-1.4',
  moon: 'M20.3 14.3A8.6 8.6 0 0 1 9.7 3.7a8.6 8.6 0 1 0 10.6 10.6',
  bell: 'M18.2 10.4a6.2 6.2 0 1 0-12.4 0c0 5.4-2.1 6.9-2.1 6.9h16.6s-2.1-1.5-2.1-6.9M13.8 20.4a2.1 2.1 0 0 1-3.6 0',
  logout:
    'M14.6 20.4h3.9a1.7 1.7 0 0 0 1.7-1.7V5.3a1.7 1.7 0 0 0-1.7-1.7h-3.9M9.7 16.7 5 12l4.7-4.7M5 12h10.3',
  'alert-circle': 'M20.4 12a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0M12 7.9v4.6M12 15.8v.6',
  'check-circle': 'M20.4 12a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0M8.3 12.2l2.6 2.6 4.8-5',
  info: 'M20.4 12a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0M12 11.4v4.7M12 7.9v.6',
  refresh:
    'M20 11.2a8 8 0 0 0-13.7-4.5L3.6 9.3M3.6 4.6v4.7h4.7M4 12.8a8 8 0 0 0 13.7 4.5l2.7-2.6M20.4 19.4v-4.7h-4.7',
  calendar:
    'M7.6 3.4v3M16.4 3.4v3M4.2 7.5a1.7 1.7 0 0 1 1.7-1.7h12.2a1.7 1.7 0 0 1 1.7 1.7v11.3a1.7 1.7 0 0 1-1.7 1.7H5.9a1.7 1.7 0 0 1-1.7-1.7zM4.2 10.6h15.6',
  key: 'M14.6 9.4a4.2 4.2 0 1 1-5.9 5.9l-.6.6H6.4v1.7H4.6v1.8H3v-2.9l5.7-5.7a4.2 4.2 0 0 1 5.9-1.4M15.6 8.4h.01',
  shield: 'M12 3.4 5 6.1v5.1c0 4.2 2.9 8.1 7 9.4 4.1-1.3 7-5.2 7-9.4V6.1zM9.2 12.1l2 2 3.6-3.7',
  copy: 'M9.4 9.4a1.7 1.7 0 0 1 1.7-1.7h7.2a1.7 1.7 0 0 1 1.7 1.7v7.2a1.7 1.7 0 0 1-1.7 1.7h-7.2a1.7 1.7 0 0 1-1.7-1.7zM5.9 16.3a1.7 1.7 0 0 1-1.7-1.7V7.4a1.7 1.7 0 0 1 1.7-1.7h7.2a1.7 1.7 0 0 1 1.7 1.7',
  archive: 'M3.6 4.6h16.8v3.8H3.6zM5.3 8.4v10a1 1 0 0 0 1 1h11.4a1 1 0 0 0 1-1v-10M9.9 12h4.2',
  /* The second subpath is the punch hole: a zero-length segment drawn as a
     dot by the round linecap, since this set strokes and never fills. */
  tag: 'M3.4 7.2a1.6 1.6 0 0 1 1.6-1.6h8.2c.4 0 .8.2 1.1.5l4.8 4.8a1.6 1.6 0 0 1 0 2.3l-4.8 4.8c-.3.3-.7.5-1.1.5H5a1.6 1.6 0 0 1-1.6-1.6zM7.2 11.8h.01',
  eye: 'M2.6 12S5.9 5.9 12 5.9 21.4 12 21.4 12 18.1 18.1 12 18.1 2.6 12 2.6 12M14.8 12a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0',
  'eye-off':
    'M9.9 6.2A7.9 7.9 0 0 1 12 5.9c6.1 0 9.4 6.1 9.4 6.1a15.6 15.6 0 0 1-2.3 3.1M6.2 7.9A15.6 15.6 0 0 0 2.6 12S5.9 18.1 12 18.1c1.4 0 2.6-.3 3.7-.8M3.4 3.4l17.2 17.2M10 10a2.8 2.8 0 0 0 4 4',
  clock: 'M20.4 12a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0M12 7.4V12l3 1.6',
  activity: 'M3.4 12.4h3.9l2.4-6.6 4 12.6 2.5-6h4.4',
  'arrow-left': 'M19.4 12H4.6M10.4 6.2 4.6 12l5.8 5.8',
  'arrow-right': 'M4.6 12h14.8M13.6 6.2 19.4 12l-5.8 5.8',
  layers: 'M12 3.4 3.4 7.7 12 12l8.6-4.3zM3.4 16.3 12 20.6l8.6-4.3M3.4 12 12 16.3l8.6-4.3',
  'layout-side':
    'M4.2 6.4a1.7 1.7 0 0 1 1.7-1.7h12.2a1.7 1.7 0 0 1 1.7 1.7v11.2a1.7 1.7 0 0 1-1.7 1.7H5.9a1.7 1.7 0 0 1-1.7-1.7zM9.4 4.7v14.6',
  'layout-top':
    'M4.2 6.4a1.7 1.7 0 0 1 1.7-1.7h12.2a1.7 1.7 0 0 1 1.7 1.7v11.2a1.7 1.7 0 0 1-1.7 1.7H5.9a1.7 1.7 0 0 1-1.7-1.7zM4.2 9.4h15.6',
  external:
    'M14.2 4.6h5.2v5.2M19.4 4.6 11.6 12.4M17 13.7v5a1.7 1.7 0 0 1-1.7 1.7H5.9a1.7 1.7 0 0 1-1.7-1.7V8.9a1.7 1.7 0 0 1 1.7-1.7h5',
} as const;

export type IconName = keyof typeof PATHS;

export const ICON_NAMES = Object.keys(PATHS) as IconName[];
